<template>
    <v-flex class="pagina-curso" xs12 fill-height>
        <header-app></header-app>
        <nav-buttons-app :mod="mod"></nav-buttons-app>
        <div class="contenido">
            <transition name="fade">
                <component key="item" :is="'mod' + $route.params.unipage + '-app'"></component>
            </transition>
        </div>
        <nav-menu-app></nav-menu-app>
    </v-flex>
</template>
<script>
    import mod0 from "./mod0";
    import mod1 from "./mod1";
    import mod2 from "./mod2";
    import mod3 from "./mod3";
    import mod4 from "./mod4";
    import mod5 from "./mod5";
    import mod6 from "./mod6";
    import mod7 from "./mod7";
    import mod8 from "./mod8";
    import mod9 from "./mod9";
    import mod10 from "./mod10";
    import mod11 from "./mod11";
    import mod12 from "./mod12";
    import mod13 from "./mod13";
    import mod14 from "./mod14";
    import mod15 from "./mod15";
    import mod16 from "./mod16";
    import mod17 from "./mod17";
    import mod18 from "./mod18";
    import mod19 from "./mod19";
    import mod20 from "./mod20";
    
    export default {
        components: {
            "mod0-app": mod0,
            "mod1-app": mod1,
            "mod2-app": mod2,
            "mod3-app": mod3,
            "mod4-app": mod4,
            "mod5-app": mod5,
            "mod6-app": mod6,
            "mod7-app": mod7,
            "mod8-app": mod8,
            "mod9-app": mod9,
            "mod10-app": mod10,
            "mod11-app": mod11,
            "mod12-app": mod12,
            "mod13-app": mod13,
            "mod14-app": mod14,
            "mod15-app": mod15,
            "mod16-app": mod16,
            "mod17-app": mod17,
            "mod18-app": mod18,
            "mod19-app": mod19,
            "mod20-app": mod20,
        },
        data() {
            return {
                noOfPages: 21,
                mod: {
                    modurl: "unidad1"
                },
                verdialogo:0,
                nombreAnimacion:'',
                cambioAction:''
            };
        },        
        computed: {
            currentPage() {
              return Math.floor(this.$route.params.unipage);
            },
            subModName() {
                return this.$store.state.subTema;
            },

        },
        methods: {
        },
        watch:{
            cambioAction(val){
                this.nombreAnimacion = val
                console.log('asdfasdfasdf' + val)
            }
        },
        // mounted y updated: Carga el número de pantallas en el store para que las flechas de navegación funcionen
        mounted() {
            this.$store.commit("screenTrack", [this.currentPage, this.noOfPages]);
        },
        updated() {
            this.$store.commit("screenTrack", [this.currentPage, this.noOfPages]);

        }
        
    };
</script>
<style lang="scss">
    // NOT SCOPED !!
    @import "../../sass/globals";

    .pagina-curso {
        background-image: url("../../assets/fondo/Hoja_Izquierda_Optima.svg");
        background-repeat: no-repeat;
        background-position: bottom left;
        background-size: 180px;
        height: 100vh;
        overflow-y: auto;
        transition: all 0.3s ease-in-out;

        .contenido {
            max-width: 100%;
            width: 1100px;
            margin: auto;
            position: relative;
            overflow: hidden;
            min-height: calc(100vh - 60px);
            height: auto;
            padding: 10px;
            margin-top: 60px;
        }
    }

// .content-scroll-enter-active, .content-scroll-leave-active{
//     transition: all 2s;
//     position: absolute;
//     max-height: 100%;
//     min-height: 100%;
//     max-width: calc(100% - 20px);
//     min-width: calc(100% - 20px);
//     overflow: hidden;

// }
// .content-scroll-enter {
//     z-index: 1;
//     transform: translateX(-100vw);
// }
// .content-scroll-leave-to {
//     transform: translateX(100vw);
// }
// .content-fade-enter-active, .content-fade-leave-active{
//     transition: all 2s;
//     position: absolute;
//     max-height: 100%;
//     min-height: 100%;
//     max-width: calc(100% - 20px);
//     min-width: calc(100% - 20px);
//     overflow: hidden;
//     opacity: 1;
// }
// .content-fade-enter {
//     z-index: 1;
//     // transform: translateX(-100vw);
//     opacity: 1;
// }
// .content-fade-leave-to {
//     // transform: translateX(100vw);
//     opacity: 0;
// }

// .content-scrollB-enter-active, .content-scrollB-leave-active{
//     transition: all 2s;
//     position: absolute;
//     max-height: 100%;
//     min-height: 100%;
//     max-width: calc(100% - 20px);
//     min-width: calc(100% - 20px);
//     overflow: hidden;
// }
// .content-scrollB-enter {
//     z-index: 1;
//     // transform: translateX(180vw);
// }
// .content-scrollB-leave-to{
//     // transform: translateX(-100vw);
// }


.fade-enter-active, .fade-leave-active {
      transition: all 2s;
    position: absolute;
    max-height: 100%;
    min-height: 100%;
    max-width: calc(100% - 20px);
    min-width: calc(100% - 20px);
    overflow: hidden;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
